import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import EfisModalDenunciaEncerramento from "../../EfisModal/EfisModalDenunciaEncerramento";
import FormAlert from "../../FormAlert/FormAlert";

const useEncerrarDenunciaOs = ({ formik }) => {
  const [showDenunciaEncerraConfirm, setshowDenunciaEncerraConfirm] = useState({
    title: null,
    body: null,
    show: false,
  });

  const [Codigo, setCodigo] = useState("");

  const {
    request: requestDenunciaEncerra,
    data: dataDenunciaEncerra,
    errors: errorsDenunciaEncerra,
    isLoading: isLoadingDenunciaEncerra,
  } = useApiClient();

  const { setErrors } = formik;

  useEffect(() => {
    if (!dataDenunciaEncerra && !errorsDenunciaEncerra) return;

    if (dataDenunciaEncerra) {
      toast.success("Denúncia encerrada com sucesso.");
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }

    if (errorsDenunciaEncerra) {
      setErrors((curr) => ({ ...curr, ...errorsDenunciaEncerra }));
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    setshowDenunciaEncerraConfirm({ show: false });
  }, [setshowDenunciaEncerraConfirm, dataDenunciaEncerra, errorsDenunciaEncerra, setErrors]);

  const excluirDocumentoDenuncia = useCallback(
    (sqDenuncia, texto) => {
      requestDenunciaEncerra(apiRoutes.fiscalizacao.procedimentoFiscal.encerrarDenuncia, {
        sqDenuncia,
        textoJustificativa: texto,
      });
    },
    [requestDenunciaEncerra],
  );

  const { request: requestVerificaDenuncia, data: dataVerificaDenuncia } = useApiClient();

  useEffect(() => {
    if (dataVerificaDenuncia) {
      const mensagem = dataVerificaDenuncia.result;
      if (mensagem === "" || mensagem == null) {
        setshowDenunciaEncerraConfirm({
          title: "Justificativa para encerramento",
          body: `Encerrar Denúncia Nº ${Codigo}`,
          show: true,
          codigo: Codigo,
          situacao: "N",
          justificar: true,
        });
      } else {
        setshowDenunciaEncerraConfirm({
          title: "Atenção!",
          body: `${mensagem}`,
          show: true,
          justificar: false,
        });
      }
    }
  }, [dataVerificaDenuncia, setshowDenunciaEncerraConfirm, Codigo]);

  const verificaDenuncia = useCallback(
    (codigo) => {
      setCodigo(codigo);
      requestVerificaDenuncia(apiRoutes.fiscalizacao.procedimentoFiscal.verificaDenuncia, { sqDenuncia: codigo });
    },
    [requestVerificaDenuncia],
  );

  const encerrarDenunciaModal = (
    <>
      <FormAlert
        formik={formik}
        data={dataDenunciaEncerra}
        errors={errorsDenunciaEncerra}
        isLoading={isLoadingDenunciaEncerra}
        dismissible
      />
      <EfisModalDenunciaEncerramento
        show={showDenunciaEncerraConfirm.show}
        title={showDenunciaEncerraConfirm.title}
        loadingConfirmationAction={isLoadingDenunciaEncerra}
        codigo={showDenunciaEncerraConfirm.codigo}
        situacao={showDenunciaEncerraConfirm.situacao}
        justificar={showDenunciaEncerraConfirm.justificar}
        closeHandler={() => setshowDenunciaEncerraConfirm({ show: false })}
        confirmationHandler={(codigo, texto) => {
          excluirDocumentoDenuncia(codigo, texto);
        }}
        body={showDenunciaEncerraConfirm.body}
      />
    </>
  );

  return {
    encerrarDenunciaModal,
    setshowDenunciaEncerraConfirm,
    verificaDenuncia,
  };
};

export default useEncerrarDenunciaOs;
